export default __webpack_public_path__ + "static/media/office2.bcd6a8bc.png";